import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { PopUpData } from '../../popupdata';
@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
	public dialogTitle:string = '';
	public dialogMsg:string = '';
	public showConfirm:boolean = true;
  public mlsMessage:string = '';
  public errorType:string = '';
  constructor(public dialogRef: MatDialogRef<PopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopUpData ) {
      this.dialogMsg = this.data.message;
      this.dialogTitle = this.data.title;
      // Show confirm button or not
      if(this.data.confirm != undefined) {
        this.showConfirm = this.data.confirm;
      }

      this.mlsMessage = (this.data.mls) ? this.data.mls : '';
      this.errorType = this.data.errorType;
  	}

  ngOnInit() {
  }

}
